import { Inbox, type LucideIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  className?: string;
}

/** "There's nothing here yet" — as distinct from an error (nothing went
 * wrong) or a restriction (nothing's blocking you either). Used for empty
 * lists/searches/documents throughout the studio. */
export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-2.5 p-8 text-center", className)}>
      <div className="grid h-10 w-10 place-items-center rounded-full bg-muted/50 text-muted-foreground">
        <Icon className="h-5 w-5" />
      </div>
      <p className="font-display text-[15px] text-foreground">{title}</p>
      {description && (
        <p className="max-w-xs text-[13px] leading-relaxed text-muted-foreground">{description}</p>
      )}
      {action && (
        <Button variant="subtle" size="sm" onClick={action.onClick} className="mt-1.5">
          {action.label}
        </Button>
      )}
    </div>
  );
}
